import React from "react";
import { Stack } from "@fluentui/react";
import styles from "./mastProfileAndFoundationPanel.module.scss";
import type MastProfileAndFoundationPanelProps from "./MastProfileAndFoundationPanelProps";
import CalculationConstructionDetailsNew from "../calculationConstructionDetails/CalculationConstructionDetailsNew";

const MastProfileAndFoundationPanelNew: React.FunctionComponent<MastProfileAndFoundationPanelProps> = ({
    selectedMastNo, 
    constructionDetails,
    calculationResults
}) => {
    return (
        <Stack grow={1} className={styles.container}>
            {selectedMastNo !== null && selectedMastNo !== undefined && constructionDetails !== undefined && (
                <>
                    <h3 className={styles.header}>Mast profile & foundation</h3>
                    <CalculationConstructionDetailsNew
                        input={constructionDetails}
                        calculationResults={calculationResults}
                        selectedMastNumber={selectedMastNo}
                    />
                </>
            )}
        </Stack>
    );
};

export default MastProfileAndFoundationPanelNew;